export default __webpack_public_path__ + "static/media/87_desktop.94fcf4af.jpg";